const ObstacleRobotWinnersList: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <section className="mb-8">
                <p className="mb-2">
                    Selamat kepada Tim Terbaik di <b>Lomba Obstacle Robot IIT Challenge 2024</b>! Kompetisi ini menampilkan ketangkasan robot dalam menavigasi berbagai rintangan dengan cerdas. Inovasi, ketelitian, dan keahlian teknik diuji secara nyata.
                </p>

                <p className="mb-4 font-semibold">Mengapa Ini Tantangan yang Seru?</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>🤖 <b>Mengasah Skill Robotik:</b> Menggabungkan teori dan praktik teknologi.</li>
                    <li>🤝 <b>Teamwork Engineering:</b> Meningkatkan kolaborasi dalam tim.</li>
                    <li>🏭 <b>Simulasi Dunia Nyata:</b> Mendekatkan peserta dengan tantangan otomasi industri.</li>
                </ul>

                <p className="mb-3 font-semibold">🎖️ Pemenang Obstacle Robot IIT Challenge 2024</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>
                        <p className="mb-2 font-semibold">🥇 Juara 1 – Tim GS Team 2 RR</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Raynard Dickinson</li>
                            <li className="font-semibold">• Raphael Benedict Rustam</li>
                            <p><i>(SMAK Penabur Gading Serpong)</i></p>
                        </ul>
                    </li>
                    <li>
                        <p className="mb-2 font-semibold">🥈 Juara 2 – Tim Excelsior</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Dave</li>
                            <li className="font-semibold">• Anderson</li>
                            <p><i>(SMAK 7 Penabur)</i></p>
                        </ul>
                    </li>
                    <li>
                        <p className="mb-2 font-semibold">🥉 Juara 3 – Tim AREVSA35</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Rendyca Susandi Putra</li>
                            <li className="font-semibold">• Raihan Baihaqqi</li>
                            <p><i>(SMAKN 35 Jakarta)</i></p>
                        </ul>
                    </li>
                </ul>

                <p className="mb-4 font-semibold">🎁 Hadiah & Manfaat Eksklusif</p>
                <p className="mb-3">Para pemenang mendapatkan benefit bernilai total ratusan juta rupiah, termasuk:</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>✅ Software Programming Bootcamp (2 Bulan) – Senilai Rp 26.550.000</li>
                    <li>✅ Robotic Race & Software Programming Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Subsidi Biaya Pendaftaran WIT Challenge 2024</li>
                </ul>
                <p className="mb-3 font-semibold">🎓 Beasiswa UKRIDA</p>
                <ul className="list-disc pl-6 mb-4">
                    <li><b>Juara 1:</b> Beasiswa penuh (SPP + uang pangkal) hingga 8 semester di Teknik Elektro, Industri, atau Sipil (IPK ≥ 3.00). Prodi lain: Gratis uang pangkal + diskon 25% SPP.</li>
                    <li><b>Juara 2:</b> Gratis uang pangkal 100% untuk semua prodi.</li>
                    <li><b>Juara 3:</b> Diskon 70% uang pangkal untuk semua prodi.</li>
                    <li><b>Semua Juara:</b> Biaya pangkal Kedokteran khusus Rp 200.000.000 (kuota Ukridian&apos;s Family, syarat berlaku).</li>
                </ul>

                <p className="mb-2 font-semibold">⚙️ Ayo Kembangkan Robot Andalmu!</p>
                <p className="mb-2">Kamu suka robotika? Tantang dirimu di ajang berikutnya dan tunjukkan kemampuanmu!</p>

                <p className="font-semibold">
                    🎥 Intip aksi robot para peserta di Instagram <a className="text-blue-500" href="https://www.instagram.com/iitchallenge2024/" target="_blank">@iitchallenge2024</a>
                </p>
            </section>
        </div>
    )
}
export default ObstacleRobotWinnersList